import { useProgress } from "@react-three/drei";

export const LoadingScreen = ({ started, onStarted }) => {
    const { progress } = useProgress();
    
    return (
        <div className="overlay-screen loadingScreen">
            <div className="board loadingScreen__board">
                <div className="loadingScreen__progress">
                    <p className="loadingScreen__text">Loading...</p>
                    <div
                        className="loadingScreen__progress__value"
                        style={{
                            width: `${progress}%`,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

